import type { FaireProductEntity } from "../../entity_types/product";

export const p_mt5k98hgpu: FaireProductEntity = {
  token: "p_mt5k98hgpu",
  type: "product",
  name: "Mushroom Reed Diffuser",
  brandToken: "b_6qajwqdzz3",
  brandName: "BigMouth Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/fdf2d8f078c132a11ba72a4848d060da8b8f5c8ecf0c3cceaa43a4a600a3f5bd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8207eb5dc84234aea367f1b6cca247a4f544be6ed4c9239f52bd9fa86cb41b8.jpeg",
    "https://cdn.faire.com/fastly/8b2a64cb26efabe4086d3237d32887bdb84b35ff920d876796205f052d553ad1.jpeg",
    "https://cdn.faire.com/fastly/ad39192284e433d7faccc5f54758344e98ebc3abba1f70a5d10abd9a2ef9c020.jpeg",
  ],
  priceDollars: 9.69,
  description:
    "Transform your home into a haven of tranquility with our Mushroom Reed Diffuser. Crafted with meticulous attention to detail, this unique home decor piece doubles as an aromatic masterpiece. Let the soothing scents and captivating design of our Mushroom Diffuser take you on a sensory journey like no other. Mushroom Magic in Every Scent: Our Mushroom Design Reed Diffuser combines aesthetics with functionality. The charming mushroom-shaped bottle is a delightful addition to any room, making it a statement piece that complements your decor effortlessly. Each detail of the mushroom, from the delicate cap to the sturdy stem, is meticulously crafted to bring nature's elegance into your space.",
  tags: [],
  msrpDollars: 19.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:18.896Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
